var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAsLabelEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "edit-02",
    clipPath: "url(#clip0_17292_78914)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M12 6.66622L9.33331 3.99955M1.66663 14.3329L3.92287 14.0822C4.19853 14.0516 4.33636 14.0362 4.46519 13.9945C4.57949 13.9575 4.68826 13.9053 4.78855 13.8391C4.9016 13.7646 4.99966 13.6665 5.19578 13.4704L14 4.66622C14.7364 3.92984 14.7364 2.73593 14 1.99955C13.2636 1.26317 12.0697 1.26317 11.3333 1.99955L2.52911 10.8037C2.33299 10.9999 2.23493 11.0979 2.16038 11.211C2.09425 11.3113 2.04197 11.42 2.00497 11.5343C1.96326 11.6632 1.94795 11.801 1.91732 12.0766L1.66663 14.3329Z",
    stroke: "#475467",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_17292_78914"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAsLabelEdit);
export default __webpack_public_path__ + "static/media/as-label-edit.e41817c530b6ca974d5e1de0b6d52492.svg";
export { ForwardRef as ReactComponent };